export const formatDate = (dateString?: string | null, seconds?: boolean) => {
	if (!dateString) return

	const date = new Date(dateString)

	const options: Intl.DateTimeFormatOptions = {
		month: 'short',
		day: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
		second: seconds ? '2-digit' : undefined,
		timeZone: 'GMT',
		hour12: false
	}

	const formattedDate = date.toLocaleString('en-US', options)
	return `${formattedDate} GMT`
}
